var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"toptitle":"Zahlungsmethode bearbeiten","name":"settings-payment-method-edit","title":_vm.paymentMethodType,"width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('SettingsPaymentMethodForm',{attrs:{"paymentMethod":_vm.paymentMethod,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }